common.View.create('habitats.website.content.items.Video', {

	video: null,

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad()
	{
		this.initPlayProgressTracking();
		this.initGateForm();
	},

	initPlayProgressTracking()
	{
		// Get video id.
		let videoId = this.element.find('.wistia_embed').data('video-id');

		// Get / create wq queue.
		window._wq = window._wq || [];

		// Listen for video ready.
		_wq.push({
			id: videoId,
			onReady: video => this.onVideoReady(video),
		});
	},

	onVideoReady(video)
	{
		//
		this.video = video;

		// Listen for percent watched changed.
		video.on('percentwatchedchanged', _.throttle(this.storeVideoPercentWatched.bind(this), 2500))
	},

	storeVideoPercentWatched(playProgress)
	{
		// Store
		$.post(
			this.element.find('.wistia_embed').attr('data-track-play-progress-url'),
			{ playProgress }
		);
	},

	initGateForm()
	{
		// Get form instance.
		let formInstance = this.element.find('.habitats-website-content-items-partials-gate-Form').data('instance');

		// Listen for unlock of gate.
		$(formInstance).on('gateUnlocked', () => this.onGateUnlocked());
	},

	onGateUnlocked()
	{
		// Fade out form.
		let form = this.element.find('.form');

		form.fadeOut('slow', () =>
		{
			// Remove form.
			form.remove();

			// @ugly We assume Wistia has already been loaded. Oterwise we might use window._wq.push({
			// Play video.
			this.video.play();
		});
	},

});